import { Component, OnInit, inject } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { ProcessedDocumentsService } from "@app/document-intelligence/services/processed-documents-service";
import { ActivatedRoute } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { ProcessedDocumentDetailModel } from "@app/document-intelligence/models/ProcessedDocumentDetailModel";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { ToastrService } from "ngx-toastr";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { CerrixCollapsingBoxComponent } from "@app/shared/cerrix-collapsing-box/cerrix-collapsing-box.component";
import { DetailOptionsComponent } from "@app/shared/components/detail-options/detail-options.component";

@Component({
    selector: "processed-document-detail",
    templateUrl: "./processed-document-detail.component.html",
    styleUrls: ["./processed-document-detail.component.scss"],
    imports: [MenuSystemDirective, CerrixCollapsingBoxComponent, DetailOptionsComponent],
})
export class ProcessedDocumentDetailComponent implements OnInit {
    private _ds = inject(ProcessedDocumentsService);
    private route = inject(ActivatedRoute);
    private _tabService = inject(TabService);
    private _pages = inject(Pages);
    private _toastr = inject(ToastrService);

    tab: TabModel;
    id: string;

    detailModel: ProcessedDocumentDetailModel;

    async ngOnInit() {
        await this.init();
    }

    async init() {
        this.id = this.route.snapshot.params.id ? this.route.snapshot.params.id : this.tab.id;

        const detail = await firstValueFrom(this._ds.getDetail(+this.id));

        this.tab.name = `(PD) ${detail.id} - ${detail.title}`;

        this.detailModel = detail;
    }

    protected async delete() {
        await firstValueFrom(this._ds.deleteProcessedDocument(this.detailModel.id));

        this._toastr.success("Processed document deleted");
        this._tabService.refresh(this._pages.ProcessedDocumentOverview);
        this.tab.close(false);
    }
}
